import { getLang, getTheme} from '../../js/core/Helpers/Helpers';

import Map from '../Map/Map';

import './less/basicGoogleMap.less';


class BasicMap extends Map{
    
    /*
      @param {#selector}
    */
    constructor(config){
        super(config);
        this.selector = config.selector || 'basicGoogleMap';
        this.sampleLat = 52.5555;
        this.sampleLng = 52.5555;
        document.getElementById(this.selector) ? this.init() : null;
    }
    
    error = msg =>{
        throw msg;
    }
    
    
    loadCmsConfig(){
        this.mapConfig = $.ajax('getMap/1');
    };
    
    loadPredefinedConfig(){
        let sel = $("#"+ this.selector);
        this.lng = sel.data('glng') !== "" ? sel.data('glng') : this.sampleLng;
        this.lat = sel.data('glat') !== "" ? sel.data('glat') : this.sampleLat;
        
        let marker = 'themes/' + getTheme() + '/images/icons/marker.png';
        let markerAnchor = new google.maps.Point(29, 69);
        
        this.mapConfig = {
            selector : this.selector,
            globalConfig :{
                zoom:16,
                zoomControl: true,
                scaleControl: false,
                center: new google.maps.LatLng(parseFloat(this.lat), parseFloat(this.lng)),
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                mapTypeControl: false,
                scrollwheel: false,
                styles:[{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}]
            },
            locations: [
                {
                    "id": 1,
                    "name": 'Victory',
                    "coords": {
                        y: parseFloat(this.lat),
                        x: parseFloat(this.lng)
                    },
                    /*			"offsetMove": {
                                    y: 50.868334,
                                    x: 19.833306
                                },*/
                    "marker" : marker,
                    "anchor" : markerAnchor
                }
            ]
        }
        
       
    }
    
    runMaps(){
        super.runMaps(this.mapConfig);
    }
    
    
    init(){
        this.isPredefined ? this.loadPredefinedConfig() : this.loadCmsConfig();
        //TODO Promise Response on loadCmsConfig then runMaps
        this.runMaps();
    }
    
}

export { BasicMap };


// WEBPACK FOOTER //
// ./components/basicGoogleMap/basicGoogleMap.js